/** parseObservationFilters produce a filter object (see example) populated
 * from the given URLSearchParams object. */
export const parseObservationsStatsFilters = (
  params /* URLSearchParams */
) => ({
  from: params.get("from"), // ISO date/time string, or key for `dateTimeProducer` fn
  to: params.get("to"), // ISO date/time string, or key for `dateTimeProducer` fn
  astrosite_id: params.get("astrosite_id"),
})
